import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { installRlsInterceptor } from "./integrations/supabase/rls-interceptor";
import { initSentry, Sentry, sentryEnabled } from "./lib/sentry";

// Initialize error monitoring as early as possible (no-op if VITE_SENTRY_DSN is not set or in preview).
initSentry();

// Install global PostgREST RLS error logger before any Supabase calls fire.
installRlsInterceptor();

// Guard: unregister service workers in preview/iframe contexts
const isInIframe = (() => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
})();

const isPreviewHost =
  window.location.hostname.includes("id-preview--") ||
  window.location.hostname.includes("lovableproject.com");

if (isPreviewHost || isInIframe) {
  navigator.serviceWorker?.getRegistrations().then((registrations) => {
    registrations.forEach((r) => r.unregister());
  });
}

const AppTree = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

createRoot(document.getElementById("root")!).render(
  sentryEnabled ? (
    <Sentry.ErrorBoundary fallback={<div style={{ padding: 24 }}>Something went wrong. The team has been notified.</div>}>
      {AppTree}
    </Sentry.ErrorBoundary>
  ) : (
    AppTree
  )
);
